module.exports = __webpack_public_path__ + "static/media/ted_x1.86fe6792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ted_x1.jpg
// module id = 202
// module chunks = 0